import React, { useState, useEffect } from "react";
import { PiStarFill, PiStarLight } from "react-icons/pi";
import toast from "react-hot-toast";
import SelectUser from "@/components/selectUser";
import api from "@/services/api";

export default ({ answer, setAnswer }) => {
  const [values, setValues] = useState();
  const [isSaving, setSaving] = useState(false);

  useEffect(() => {
    setValues(answer);
  }, [answer]);

  if (!values) return null;

  async function updateAnswer() {
    try {
      setSaving(true);
      const { ok, data } = await api.put(`/mission_ao_answer/${values._id}`, values);
      if (!ok) throw new Error("Failed to update answer");

      setAnswer(data);
      toast.success("Answer updated successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Error updating answer");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-lg font-medium text-gray-800 mb-6 pb-3 border-b border-gray-100">Response Details</h2>

      <div className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Title</label>
            <input
              className="input w-full focus:ring-2 focus:ring-blue-500 transition-all border-gray-200 rounded-md shadow-sm"
              value={values.title}
              onChange={(e) => setValues({ ...values, title: e.target.value })}
              placeholder="Enter proposal title"
            />
          </div>

          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Status</label>
            <select
              className="input w-full focus:ring-2 focus:ring-blue-500 transition-all border-gray-200 rounded-md shadow-sm bg-white"
              value={values.status}
              onChange={(e) => setValues({ ...values, status: e.target.value })}>
              <option value="pending">Pending</option>
              <option value="need_info">Need Info</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
              <option value="waiting result">Waiting Result</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Submission Date</label>
            <input
              type="date"
              className="input w-full focus:ring-2 focus:ring-blue-500 transition-all border-gray-200 rounded-md shadow-sm"
              value={values.date ? new Date(values.date).toISOString().split("T")[0] : ""}
              onChange={(e) => setValues({ ...values, date: new Date(e.target.value).toISOString() })}
            />
          </div>

          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Amount</label>
            <div className="relative">
              <input
                type="number"
                className="input w-full pl-8 focus:ring-2 focus:ring-blue-500 transition-all border-gray-200 rounded-md shadow-sm"
                value={values.montant}
                onChange={(e) => setValues({ ...values, montant: e.target.value })}
                placeholder="Enter amount"
              />
              <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">€</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Company</label>
            <input
              className="input w-full focus:ring-2 focus:ring-blue-500 transition-all border-gray-200 rounded-md shadow-sm"
              value={values.entreprise}
              placeholder="Enter company name"
              onChange={(e) => setValues({ ...values, entreprise: e.target.value })}
            />
          </div>

          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">Lead Contact</label>
            <SelectUser
              value={values.user_id ? { _id: values.user_id, name: values.user_name, avatar: values.user_avatar } : null}
              onChange={(user) => {
                if (!user) return;
                setValues({ ...values, user_id: user._id, user_name: user.name, user_avatar: user.avatar });
              }}
            />
          </div>
        </div>

        <div className="py-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">Quality Rating</label>
          <div className="flex items-center justify-start text-2xl text-yellow-400">
            {[1, 2, 3, 4, 5].map((score) => {
              const isShining = score <= values.note;
              return (
                <div
                  key={score}
                  className={`px-1 hover:scale-110 transition-transform cursor-pointer ${isShining ? "text-yellow-400" : "text-gray-200"}`}
                  onClick={() => setValues({ ...values, note: score })}>
                  {isShining ? <PiStarFill /> : <PiStarLight />}
                </div>
              );
            })}
          </div>
        </div>

        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <textarea
            className="input w-full h-32 focus:ring-2 focus:ring-blue-500 transition-all border-gray-200 rounded-md shadow-sm"
            value={values.description}
            onChange={(e) => setValues({ ...values, description: e.target.value })}
            placeholder="Add details about this proposal..."
          />
        </div>

        <div className="flex justify-end pt-4 border-t border-gray-100 mt-6">
          <button
            className={`px-6 py-2.5 rounded-md shadow-sm transition-all ${isSaving ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700 hover:shadow"} text-white`}
            onClick={updateAnswer}
            disabled={isSaving}>
            {isSaving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};
